import { Nullable } from '@gv/triage-components';

import { ExportFormValues } from 'store/api/analytics-export';

export enum AnalyticsExportStatus {
  Error = 'error',
  Ready = 'ready',
  Initial = 'initial',
  Processing = 'processing',
  FileCreated = 'fileCreated',
  DataPrepared = 'dataPrepared',
}

export interface AnalyticsExportState {
  caseId: any;
  hospitalId: any;
  queueRoomId: string;
  file: Nullable<string>;
  isButtonHide?: boolean;
  isShowFeedback?: boolean;
  panelMinimized?: boolean;
  callFlowTextOut?: boolean;
  isShowPlanForCVT?: boolean;
  queueAlertResetKey?: number;
  callFlowInProgress?: boolean;
  status: AnalyticsExportStatus;
  is_hospital_edit_enabled?: boolean;
  formValues: Nullable<ExportFormValues>;
}
